<template >
    <div class="container-fluid" v-if="item">


      <div class="row">
        <div class="col-lg-12">
          <div class="card shadow mb-4">
            <div class="card-header">
              <h2>{{item.name}}</h2>
            </div>
            <div class="card-body">
              <p>{{item.description}}</p>
              <div
                class="row text-center text-lg-left mt-5"
                v-if="item.images!=null && item.images.length>0"
              >
                <div
                  class="col-lg-3 col-md-4 col-6"
                  v-for="(file) in item.images"
                  v-bind:key="file.fileUrl"
                >
                  <a href="#" class="d-block mb-4 h-100">
                    <img class="img-fluid" :src="file.fileUrl" />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      <!-- <div class="col-lg-4">
        <div class="card shadow mb-4">
          <div class="card-header">
            <h2>Мэдээлэл</h2>
          </div>
          <div class="card-body">
            <p>Багш: {{lesson.profession}}</p>
            <p>Xичээлийн код: {{lesson.lectureCode}}</p>
            <p v-if="lesson.semester">Улирал: {{lesson.semester.id}}</p>
            <p v-if="lesson.school">Сургууль: {{lesson.school.id}}</p>
            <p v-if="lesson.department">Xөтөлбөрийн баг: {{lesson.department.id}}</p>
            <p v-if="lesson.program">Хөтөлбөр: {{lesson.program.id}}</p>
          </div>
        </div>
      </div> -->


    </div>

    </div> 
</template>

<script>
const fb = require('../firebaseConfig.js')
import { mapState } from 'vuex'
import moment from 'moment'

export default {
    name: "ItemDetail",
    data() {
        return {
            item: null,
            topic:{
              'name':null,
              'description':null
            },
            topics:[],
            types:[],
            selectedType:null,
            studentsText:'',
            tmpStudents:[],
            tmpAdditionalFile:{
              'name':'',
              'uploading':false,
              'uploadPercent':null
              
            }
            
        };
    },
    methods: {
        
      _getQA(){
      
          fb.db.doc(this.selbegPath).onSnapshot(doc=> {
              let item=doc.data();
              item.id=doc.id;
              this.item=item;
            
          });

      },

   
      uploadFile(topic, selectedType){
        var _this=this;
        var files = this.$refs['file_'+topic.id][0].files
        if(files!=null && files.length>0){
          var file=files[0]
          var now=new Date();
          var uploadTask = fb.storageRef.child(now.getTime()+"_"+file.name).put(file);
          topic.uploading=true
          topic.uploadPercent=0
          uploadTask.on(fb.storage.TaskEvent.STATE_CHANGED,
            function(snapshot) {
              var progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
              topic.uploadPercent=progress
            }, function(error) {
            switch (error.code) {
              case 'storage/unauthorized':
                break;

              case 'storage/canceled':
                break;


              case 'storage/unknown':
                break;
            }
          }, 
          function() {
            uploadTask.snapshot.ref.getDownloadURL().then(function(downloadURL) {
              
              let fileObject={
                'fileName': file.name,
                'fileUrl':downloadURL,
                'uploadedAt': now
              }
              fb.db.collection("lessons").doc(_this.selbegId).collection(selectedType).doc(topic.id).update(
                {
                    files: fb.firestore.FieldValue.arrayUnion(fileObject)
                }
              )
              topic.uploading=false
              topic.uploadPercent=0
             
            });
          });
        }
        
      },
      uploadFile1(){
        if(this.tmpAdditionalFile.name!=null && this.tmpAdditionalFile.name!=''){
        var _this=this;
        var files = this.$refs['lessonFile_'+this.lesson.id].files

        if(files!=null && files.length>0){
          var file=files[0]
          var now=new Date();
          var uploadTask = fb.storageRef.child(now.getTime()+"_"+file.name).put(file);
          _this.tmpAdditionalFile.uploading=true
          _this.tmpAdditionalFile.uploadPercent=0
          uploadTask.on(fb.storage.TaskEvent.STATE_CHANGED,
            function(snapshot) {
              // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
              var progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
              _this.tmpAdditionalFile.uploadPercent=progress
            }, function(error) {
            // https://firebase.google.com/docs/storage/web/handle-errors
            switch (error.code) {
              case 'storage/unauthorized':
                break;

              case 'storage/canceled':
                break;


              case 'storage/unknown':
                break;
            }
          }, 
          function() {
            uploadTask.snapshot.ref.getDownloadURL().then(function(downloadURL) {
              
              let fileObject={
                'title': _this.tmpAdditionalFile.name,
                'fileName': file.name,
                'fileUrl':downloadURL,
                'uploadedAt': now
              }
              fb.db.collection("lessons").doc(_this.selbegId).update(
                {
                    files: fb.firestore.FieldValue.arrayUnion(fileObject)
                }
              )

              _this.tmpAdditionalFile={
                'name':'',
                'uploading':false,
                'uploadPercent':null
                
              }
              _this.$refs['lessonFile_'+_this.lesson.id].value = ''

              if(!/safari/i.test(navigator.userAgent)){
                _this.$refs['lessonFile_'+_this.lesson.id].type = ''
                _this.$refs['lessonFile_'+_this.lesson.id].type = 'file'
              }
            });
          });
        }
        }
      },

    
      _deleteTopicFile(type,topic, file, index){
        var result = confirm("Та "+file.fileName+" файлыг устгах уу?");
          if (result) {
            var fileName=file.fileName+"_"+file.uploadedAt.toDate().getTime()
            var fileRef = fb.storageRef.child(fileName);
            // Delete the file
            fileRef.delete().then(() =>{
              topic.files.splice(index, 1)
              fb.db.collection("lessons").doc(this.lessonId).collection(type).doc(topic.id).update({
                  files: topic.files
                }
              )
            }).catch(function(error) {

            });
              
          }
      }
      ,
      _deleteLessonFile(file, index){
        var result = confirm("Та "+file.title+" файлыг устгах уу?");
          if (result) {
            var fileName=file.fileName+"_"+file.uploadedAt.toDate().getTime()
            var fileRef = fb.storageRef.child(fileName);
            // Delete the file
            fileRef.delete().then(() =>{
              this.lesson.files.splice(index, 1)
              fb.db.collection("lessons").doc(this.lessonId).update({
                  files: this.lesson.files
                }
              )
            }).catch(function(error) {

            });
              
          }
      }
    },
    computed: {
        ...mapState(['userProfile', 'currentUser'])
    },
    props: {
        selbegPath: { 
            required: true,
        }
    },
    created() {
        var _this=this;
        if(this.selbegPath!=null && this.selbegPath!='')
          this._getQA();
            
    },
    filters: {
		  formatDate(val) {
        if(val!=null){
          if (!val) { return '-' }
          let date = val.toDate()
          return moment(date).fromNow()
        }
        return '-'
      },
    
    }
  
};
</script>

